import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyHero from "./sections/PrivacyHero";
import PolicyContent from "./sections/PolicyContent";
import NeedHelpSection from "./sections/NeedHelpSection";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <PrivacyHero />
      <PolicyContent />
      <NeedHelpSection />
      <Footer />
    </div>;
}